import React, { useState } from "react"
import { Box, Paper, Stack, Typography } from "@mui/material"
import CodeViewer from "../../../../components/CodeViewer/code-viewer"
import GenericRadioButton from "../../../../components/radio-button/generic-radio-button"

const GenericRadioButtonPage = () => {
    const [selected, setSelected] = useState("viewer")

    const optionsExample = [
        { value: "admin", label: "Administrador" },
        { value: "editor", label: "Editor" },
        { value: "viewer", label: "Visualizador" },
        { value: "guest", label: "Convidado" },
    ]

    const codeBasicUsage = `import GenericRadioButton from "src/v2/components/generic-radio-button/generic-radio-button"

const options = [
  { value: "admin", label: "Administrador" },
  { value: "editor", label: "Editor" },
  { value: "viewer", label: "Visualizador" },
  { value: "guest", label: "Convidado" },
]

<GenericRadioButton
  title="Nível de acesso"
  radioButtonItems={options}
  defaultRadioValue="viewer"
  onChange={(event) => console.log(event.target.value)}
/>`

    const codePropsType = `type GenericRadioButtonOption = {
  value: string
  label: string
}

type GenericRadioButtonProps = {
  title: string
  radioButtonItems: GenericRadioButtonOption[]
  defaultRadioValue: string
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
}`

    return (
            <Box>
                <Stack spacing={3}>

                    {/* INTRO + EXEMPLO PRINCIPAL */}
                    <Paper>
                        <Box p={3}>
                            <Typography variant="h4" gutterBottom color="common.white">
                                {`GenericRadioButton`}
                            </Typography>

                            <Typography variant="body2" color="text.secondary">
                                {`O componente GenericRadioButton encapsula um grupo de botões de rádio (RadioGroup do MUI) com estilos padronizados do design system. Ele é indicado para seleções de opção única em formulários, com poucas opções.`}
                            </Typography>

                            <Box mt={3}>
                                <Typography variant="h6" gutterBottom color="common.white">
                                    {`Exemplo principal`}
                                </Typography>

                                <Typography variant="body2" color="text.secondary" paragraph>
                                    {`Exemplo de uso para seleção de nível de acesso. O valor selecionado é controlado via estado local.`}
                                </Typography>

                                <Box mt={2} sx={{ maxWidth: 420 }}>
                                    <GenericRadioButton
                                        title="Nível de acesso"
                                        radioButtonItems={optionsExample}
                                        defaultRadioValue={selected}
                                        onChange={(event) => setSelected(event.target.value)}
                                    />
                                </Box>
                            </Box>
                        </Box>
                    </Paper>

                    {/* USO BÁSICO */}
                    <Paper>
                        <Box p={3}>
                            <Typography variant="h6" gutterBottom color="common.white">
                                {`Uso básico`}
                            </Typography>

                            <Typography variant="body2" color="text.secondary" paragraph>
                                {`Abaixo um exemplo mínimo de configuração das opções e captura do valor selecionado no onChange.`}
                            </Typography>

                            <Paper variant="outlined">
                                <Box p={2}>
                                    <CodeViewer code={codeBasicUsage} language="jsx" />
                                </Box>
                            </Paper>
                        </Box>
                    </Paper>

                    {/* PROPRIEDADES DO COMPONENTE */}
                    <Paper>
                        <Box p={3}>
                            <Typography variant="h6" gutterBottom color="common.white">
                                {`Propriedades do componente`}
                            </Typography>

                            <Typography variant="body2" color="text.secondary" paragraph>
                                {`Principais propriedades expostas pelo GenericRadioButton. Ele recebe uma lista de opções e um valor padrão, e dispara o onChange sempre que o usuário altera a seleção.`}
                            </Typography>

                            <Paper variant="outlined">
                                <Box p={2}>
                                    <Typography variant="subtitle2" gutterBottom color="common.white">
                                        {`Tipo das props (exemplo em TypeScript`}
                                        {`)`}
                                    </Typography>
                                    <CodeViewer code={codePropsType} language="tsx" />
                                </Box>
                            </Paper>
                        </Box>
                    </Paper>

                </Stack>
            </Box>
    )
}

export default GenericRadioButtonPage